// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order_order_container__lqb-t {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-left: none;
  border-top: none;
  padding: 19px;
}
@media screen and (max-width: 781px) {
  .order_order_container__lqb-t {
    border: none;
    padding: 14px;
  }
}
.order_order_container__lqb-t .order_analytics__PBrrZ {
  flex-direction: column;
  gap: 20px;
}
@media (max-width: 781px) {
  .order_order_container__lqb-t .order_analytics__PBrrZ {
    flex-direction: unset;
  }
}
.order_order_container__lqb-t .order_plan__51En2,
.order_order_container__lqb-t .order_analytics__PBrrZ {
  border-radius: 12px;
  border: 1px solid var(--re-border-color);
  display: flex;
  flex-wrap: wrap;
  padding: 15px 18px 20px;
}
.order_order_container__lqb-t .order_plan__51En2 .order_bland__8jKtV,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_bland__8jKtV {
  width: 50%;
}
.order_order_container__lqb-t .order_plan__51En2 .order_bland__8jKtV .order_bland_icon__-YJHB,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_bland__8jKtV .order_bland_icon__-YJHB {
  display: flex;
}
.order_order_container__lqb-t .order_plan__51En2 .order_bland__8jKtV span,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_bland__8jKtV span {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 7px;
}
.order_order_container__lqb-t .order_plan__51En2 .order_bland__8jKtV .order_brand_title__onWh1,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_bland__8jKtV .order_brand_title__onWh1 {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 6px;
}
.order_order_container__lqb-t .order_plan__51En2 .order_bland__8jKtV .order_brand_description__1HMXr,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_bland__8jKtV .order_brand_description__1HMXr {
  width: 288px;
  max-width: 288px;
  min-width: 288px;
  color: var(--font-dark-color);
  font-size: 12px;
  text-align: left;
  font-weight: 500;
  line-height: 18px;
  margin-top: 10px;
}
.order_order_container__lqb-t .order_plan__51En2 .order_footer__lykIn,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_footer__lykIn {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-top: 25px;
  gap: 9px;
}
@media screen and (max-width: 781px) {
  .order_order_container__lqb-t .order_plan__51En2 .order_footer__lykIn,
  .order_order_container__lqb-t .order_analytics__PBrrZ .order_footer__lykIn {
    flex-direction: column;
  }
  .order_order_container__lqb-t .order_plan__51En2 .order_footer__lykIn button,
  .order_order_container__lqb-t .order_analytics__PBrrZ .order_footer__lykIn button {
    width: 100% !important;
    left: 0px;
  }
}
.order_order_container__lqb-t .order_plan__51En2 .order_data_range__H\\+GyB,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_data_range__H\\+GyB {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 15px;
}
.order_order_container__lqb-t .order_plan__51En2 .order_data_range__H\\+GyB .order_option__uxlxZ,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_data_range__H\\+GyB .order_option__uxlxZ {
  width: calc(50% - 15px);
  display: inline-block;
}
@media screen and (max-width: 781px) {
  .order_order_container__lqb-t .order_plan__51En2 .order_data_range__H\\+GyB .order_option__uxlxZ,
  .order_order_container__lqb-t .order_analytics__PBrrZ .order_data_range__H\\+GyB .order_option__uxlxZ {
    width: 100%;
  }
}
.order_order_container__lqb-t .order_plan__51En2 .order_data_range__H\\+GyB .order_option__uxlxZ .order_label__CtgFV,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_data_range__H\\+GyB .order_option__uxlxZ .order_label__CtgFV {
  width: 100%;
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
.order_order_container__lqb-t .order_plan__51En2 .order_data_range__H\\+GyB .order_option__uxlxZ input,
.order_order_container__lqb-t .order_plan__51En2 .order_data_range__H\\+GyB .order_option__uxlxZ select,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_data_range__H\\+GyB .order_option__uxlxZ input,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_data_range__H\\+GyB .order_option__uxlxZ select {
  width: 100%;
  height: 42px;
  margin-top: 5px;
  background-color: var(--re-select-dark-bg);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
@media screen and (max-width: 781px) {
  .order_order_container__lqb-t .order_plan__51En2 .order_data_range__H\\+GyB .order_option__uxlxZ input,
  .order_order_container__lqb-t .order_plan__51En2 .order_data_range__H\\+GyB .order_option__uxlxZ select,
  .order_order_container__lqb-t .order_analytics__PBrrZ .order_data_range__H\\+GyB .order_option__uxlxZ input,
  .order_order_container__lqb-t .order_analytics__PBrrZ .order_data_range__H\\+GyB .order_option__uxlxZ select {
    width: 100%;
    margin-right: 0;
    margin-top: 10px;
  }
}
.order_order_container__lqb-t .order_plan__51En2 .order_search__gDHzm,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_search__gDHzm {
  width: 50%;
}
.order_order_container__lqb-t .order_plan__51En2 .order_search__gDHzm .order_brand_label__LCXpf,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_search__gDHzm .order_brand_label__LCXpf {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  float: right;
}
.order_order_container__lqb-t .order_plan__51En2 .order_search__gDHzm div,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_search__gDHzm div {
  width: 272px;
  height: 42px;
  margin-top: 33px;
  margin-right: -50px;
  float: right;
}
.order_order_container__lqb-t .order_plan__51En2 .order_search__gDHzm div input,
.order_order_container__lqb-t .order_analytics__PBrrZ .order_search__gDHzm div input {
  width: 100%;
}
@media screen and (max-width: 781px) {
  .order_order_container__lqb-t .order_plan__51En2 .order_search__gDHzm div,
  .order_order_container__lqb-t .order_analytics__PBrrZ .order_search__gDHzm div {
    width: 100%;
    margin-right: 0;
    margin-top: 10px;
  }
}
@media (max-width: 781px) {
  .order_order_container__lqb-t .order_plan__51En2 .order_bland__8jKtV,
  .order_order_container__lqb-t .order_plan__51En2 .order_search__gDHzm {
    width: 100%;
  }
  .order_order_container__lqb-t .order_plan__51En2 .order_search__gDHzm {
    margin-top: 13px;
  }
  .order_order_container__lqb-t .order_plan__51En2 .order_search__gDHzm .order_brand_label__LCXpf {
    float: left;
    margin-left: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/hybrid-orders/order.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AACF;AACE;EARF;IASI,YAAA;IACA,aAAA;EAEF;AACF;AAAE;EACE,sBAAA;EACA,SAAA;AAEJ;AAAI;EAJF;IAKI,qBAAA;EAGJ;AACF;AAAE;;EAEE,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAEJ;AAAI;;EACE,UAAA;AAGN;AADM;;EACE,aAAA;AAIR;AADM;;EACE,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAIR;AADM;;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAIR;AADM;;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAIR;AAAI;;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,QAAA;AAGN;AADM;EAPF;;IAQI,sBAAA;EAKN;EAHM;;IACE,sBAAA;IACA,SAAA;EAMR;AACF;AAFI;;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,SAAA;AAKN;AAJM;;EACE,uBAAA;EACA,qBAAA;AAOR;AALQ;EAJF;;IAKI,WAAA;EASR;AACF;AAPQ;;EACE,WAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAUV;AAPQ;;;;EAEE,WAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AAWV;AATU;EAjBF;;;;IAkBI,WAAA;IACA,eAAA;IACA,gBAAA;EAeV;AACF;AAVI;;EACE,UAAA;AAaN;AAXM;;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAcR;AAXM;;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAcR;AAZQ;;EACE,WAAA;AAeV;AAZQ;EAXF;;IAYI,WAAA;IACA,eAAA;IACA,gBAAA;EAgBR;AACF;AAXI;EACE;;IAEE,WAAA;EAaN;EAVI;IACE,gBAAA;EAYN;EAVM;IACE,WAAA;IACA,gBAAA;EAYR;AACF","sourcesContent":[".order_container {\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--sb-border-color);\n  border-left: none;\n  border-top: none;\n  padding: 19px;\n\n  @media screen and (max-width: 781px) {\n    border: none;\n    padding: 14px;\n  }\n\n  .analytics {\n    flex-direction: column;\n    gap: 20px;\n\n    @media (max-width: 781px) {\n      flex-direction: unset;\n    }\n  }\n\n  .plan,\n  .analytics {\n    border-radius: 12px;\n    border: 1px solid var(--re-border-color);\n    display: flex;\n    flex-wrap: wrap;\n    padding: 15px 18px 20px;\n\n    .bland {\n      width: 50%;\n\n      .bland_icon {\n        display: flex;\n      }\n\n      span {\n        color: var(--font-dark-color);\n        font-family: Red Hat Display;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        margin-top: 7px;\n      }\n\n      .brand_title {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        margin-left: 6px;\n      }\n\n      .brand_description {\n        width: 288px;\n        max-width: 288px;\n        min-width: 288px;\n        color: var(--font-dark-color);\n        font-size: 12px;\n        text-align: left;\n        font-weight: 500;\n        line-height: 18px;\n        margin-top: 10px;\n      }\n    }\n\n    .footer {\n      display: flex;\n      justify-content: flex-end;\n      width: 100%;\n      padding-top: 25px;\n      gap: 9px;\n\n      @media screen and (max-width: 781px) {\n        flex-direction: column;\n\n        button {\n          width: 100% !important;\n          left: 0px;\n        }\n      }\n    }\n\n    .data_range {\n      display: flex;\n      justify-content: flex-start;\n      flex-wrap: wrap;\n      gap: 15px;\n      .option {\n        width: calc(50% - 15px);\n        display: inline-block;\n\n        @media screen and (max-width: 781px) {\n          width: 100%;\n        }\n\n        .label {\n          width: 100%;\n          color: var(--font-color);\n          font-family: Red Hat Display;\n          font-size: 14px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: normal;\n          text-align: left;\n        }\n\n        input,\n        select {\n          width: 100%;\n          height: 42px;\n          margin-top: 5px;\n          background-color: var(--re-select-dark-bg);\n          border-radius: 12px;\n          border: 1px solid transparent;\n          color: var(--font-dark-color);\n          font-family: Red Hat Display;\n          font-size: 16px;\n          font-style: normal;\n          font-weight: 600;\n          line-height: normal;\n          padding: 11px 20px 10px 16px;\n          margin-top: 17px;\n\n          @media screen and (max-width: 781px) {\n            width: 100%;\n            margin-right: 0;\n            margin-top: 10px;\n          }\n        }\n      }\n    }\n\n    .search {\n      width: 50%;\n\n      .brand_label {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        float: right;\n      }\n\n      div {\n        width: 272px;\n        height: 42px;\n        margin-top: 33px;\n        margin-right: -50px;\n        float: right;\n\n        input {\n          width: 100%;\n        }\n\n        @media screen and (max-width: 781px) {\n          width: 100%;\n          margin-right: 0;\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n  .plan {\n    @media (max-width: 781px) {\n      .bland,\n      .search {\n        width: 100%;\n      }\n\n      .search {\n        margin-top: 13px;\n\n        .brand_label {\n          float: left;\n          margin-left: 5px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order_container": `order_order_container__lqb-t`,
	"analytics": `order_analytics__PBrrZ`,
	"plan": `order_plan__51En2`,
	"bland": `order_bland__8jKtV`,
	"bland_icon": `order_bland_icon__-YJHB`,
	"brand_title": `order_brand_title__onWh1`,
	"brand_description": `order_brand_description__1HMXr`,
	"footer": `order_footer__lykIn`,
	"data_range": `order_data_range__H+GyB`,
	"option": `order_option__uxlxZ`,
	"label": `order_label__CtgFV`,
	"search": `order_search__gDHzm`,
	"brand_label": `order_brand_label__LCXpf`
};
export default ___CSS_LOADER_EXPORT___;
